import { InfoCircleOutlined } from "@ant-design/icons"
import { Tooltip } from "antd"
import React from "react"

interface Props extends React.ComponentProps<typeof InfoCircleOutlined> {
  text?: string
}

export const InfoIcon = (props: Props) => {
  const {
   text,
   ...iconProps
  } = props

  const component = <InfoCircleOutlined {...iconProps} />

  if (text) {
    return (
      <Tooltip title={text}>
        {component}
      </Tooltip>
    )
  } else {
    return component
  }
}